import { useState, useEffect } from "react";

export default function Carousel({ slides }) {
    const [current, setCurrent] = useState(0);

    // Autoplay functionality
    useEffect(() => {
        const interval = setInterval(() => {
            setCurrent((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
        }, 3000); // Change slide every 3 seconds

        return () => clearInterval(interval); // Cleanup on unmount
    }, [slides.length]);

    return (
        <div className="slider w-full max-w-4xl mx-auto relative">
            <div className="slider-content overflow-hidden relative w-full h-[100%] sm:h-[100%] lg:h-[100%]">
                <div
                    className="flex transition-transform ease-out duration-500"
                    style={{
                        transform: `translateX(-${current * 100}%)`,
                    }}
                >
                    {slides.map((s, index) => (
                        <img
                            key={index}
                            src={s}
                            alt={`Slide ${index}`}
                            className="w-full h-full object-cover"
                        />
                    ))}
                </div>
            </div>

            {/* Navigation Dots */}
            <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex gap-2">
                {slides.map((_, i) => (
                    <button
                        key={i}
                        onClick={() => setCurrent(i)}
                        className={`w-3 h-3 rounded-full transition-all duration-300 ${
                            i === current ? "bg-white scale-125" : "bg-gray-500"
                        }`}
                    ></button>
                ))}
            </div>
        </div>
    );
}
